<script setup lang="ts">
    import PTAHero from './../PTA-Family/HeroSection/PTAHero.vue';
    import HeroSection from './HeroSection.vue';
    import FachkreisHero from './../Fachkreis/FachkreisHero.vue';
    import AcademyHero from '../Academy/AcademyHero.vue';
    import UrologyHero from '~/components/urology/Hero/UrologyHero.vue';
    import NephrologyHero from '~/components/nephrology/Hero/NephrologyHero.vue';
    import { LOCALE_PREFIX_REGEX } from '~/utils/localePattern';
    import type { SectionId } from '~/types/sectionId';

    const props = defineProps<{
        blok: HeroComponentStoryblok;
    }>();

    const route = useRoute();
    const { context } = usePlatformMeta();

    // TODO: verify is sectionId is the intended key or if it should be the theme name
    const heroComponentMap: Record<SectionId, Component> = {
        root: HeroSection,
        fachportal: FachkreisHero,
        'pta-family': PTAHero,
        academy: AcademyHero,
        urology: UrologyHero,
        nephrology: NephrologyHero
    };

    const resolvedVariant = ref<SectionId>(context.value);

    const isRealRootRoute = computed(() => {
        const normalizedPath = route.path.replace(/^\//, '');

        return normalizedPath === '' || LOCALE_PREFIX_REGEX.test(normalizedPath);
    });

    watch(
        [context, isRealRootRoute],
        ([value, isRootRoute]) => {
            const nextVariant = value;

            if (nextVariant !== 'root') {
                resolvedVariant.value = nextVariant;
                return;
            }

            if (isRootRoute) {
                resolvedVariant.value = 'root';
            }
        },
        { immediate: true }
    );

    const currentHeroComponent = computed(() => {
        return heroComponentMap[resolvedVariant.value] ?? HeroSection;
    });
</script>

<template>
    <component
        :is="currentHeroComponent"
        :blok="props.blok"
    />
</template>
